// ConfirmInstructorResult.jsx
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function ConfirmInstructorResult() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const status = (params.get("status") || "pending").toLowerCase();

  const ui = useMemo(() => {
    switch (status) {
      case "confirmed":
        return { title: "¡Gracias!", text: "Tu confirmación fue registrada.", cls: "alert alert-success" };
      case "declined":
        return { title: "Gracias", text: "Has rechazado la participación.", cls: "alert alert-warning" };
      case "invalid":
        return { title: "Token inválido", text: "El enlace no es válido o expiró.", cls: "alert alert-danger" };
      default:
        return { title: "Estado desconocido", text: "No pudimos determinar el estado.", cls: "alert alert-secondary" };
    }
  }, [status]);

  return (
    <div className="container" style={{ maxWidth: 640 }}>
      <div className={ui.cls} role="alert">
        <h4 className="alert-heading">{ui.title}</h4>
        <p>{ui.text}</p>
      </div>
    </div>
  );
}